// FarmCard.jsx (Refactored with useParentPoolAPR hook)
import React from 'react';
import { Link } from 'react-router-dom';
import Tvl from '../../../../shared/Tvl';
import { useParentPoolAPR } from '../../../../hooks/useParentPoolAPR';

const FarmCard = ({ farm }) => {
    const {
        projectName,
        logo,
        rewardAmount,
        childCount,
        link,
        contractAddress,
        poolEndDate,
        symbol,
        createdAt
    } = farm;

    const { apr } = useParentPoolAPR(contractAddress, rewardAmount, poolEndDate,null, createdAt);
    console.log(farm, createdAt, 'apr in farm card');
    return (
        <Link to={link}>
            <div className='cards'>
                <div className='top_cards'>
                    <img src={logo} className='imginner' alt={projectName} />
                    <h3>{projectName || 'Pool Name'}</h3>
                </div>
                <div className='flexxside'>
                    <p>TVL</p>
                    <span>
                        <Tvl
                            contractAddress={contractAddress}
                            poolType='rootPool'
                            tokenAddress={farm?.rewardToken}
                        />
                    </span>
                </div>
                <div className='flexxside'>
                    <p>Rewards</p>
                    <span>{parseFloat(rewardAmount || 0)} {symbol}</span>
                </div>
                <div className='flexxside'>
                    <p>Pools</p>
                    <span>{childCount || 0}</span>
                </div>
                <div className='flexxside'>
                    <p>APR</p>
                    <span>{apr}%</span>
                </div>
                <button>
                    View Farm <img src='\assets\smallarow.svg' alt="arrow" />
                </button>
            </div>
        </Link>
    );
};

export default FarmCard;